import { AnalyticIdentifier } from '@common/neo.tax';
import { ReactComponent as EmployeeIcon } from '@ui-components/neo.tax/dist/icons/employee.svg';
import { ReactComponent as ProjectsIcon } from '@ui-components/neo.tax/dist/icons/presentation-projector-screen-hierarchy.svg';

import { getPath, NavSection, Path } from '@neo.tax/shared';
import { SideNavItemProps, SideNavProps } from '@neo.tax/shared/organisms';

export const sredPaths = [Path.SRED_PROJECTS, Path.SRED_PAYROLL_EXPENSES] as const;

export type SredPath = (typeof sredPaths)[number];

interface SredPathItem {
  path: SredPath;
  title: string;
  icon: React.ReactElement;
  id: string;
  hideIfNonFinancialUser: boolean;
}

export const SRED_PATHS: SredPathItem[] = [
  {
    path: Path.SRED_PROJECTS,
    title: 'SR&ED Projects',
    icon: <ProjectsIcon />,
    id: `${AnalyticIdentifier.ENTERPRISE_NAV_SRED_PROJECTS}`,
    hideIfNonFinancialUser: false,
  },
  {
    path: Path.SRED_PAYROLL_EXPENSES,
    title: 'SR&ED Payroll Expenses',
    icon: <EmployeeIcon />,
    id: `${AnalyticIdentifier.ENTERPRISE_NAV_SRED_PAYROLL_EXPENSES}`,
    hideIfNonFinancialUser: false,
  },
];

export const isSredPathAvailable = ({
  isNonFinancialUser,
  path,
}: {
  isNonFinancialUser: boolean;
  path: SredPath;
}): boolean => {
  const { hideIfNonFinancialUser } = SRED_PATHS.find((p) => p.path === path) ?? {};

  if (hideIfNonFinancialUser && isNonFinancialUser) {
    return false;
  }

  return true;
};

export const getSredNavSection = ({
  companyId,
  fiscalYearId,
  isNonFinancialUser,
}: {
  isNonFinancialUser: boolean;
  companyId: string;
  fiscalYearId: string;
}): SideNavProps['sections'] => {
  const sredNavItems = SRED_PATHS.filter((sredPathItem) =>
    isSredPathAvailable({ isNonFinancialUser, path: sredPathItem.path }),
  ).reduce((acc: SideNavItemProps[], sredPathItem) => {
    const { icon, id, path, title } = sredPathItem;
    acc.push({
      id,
      title,
      icon,
      to: getPath({ path, companyId, fiscalYearId }),
    });
    return acc;
  }, []);

  return [{ title: NavSection.RD_TAX_CREDIT, items: sredNavItems }];
};
